'use client';
import { useRouter, useSearchParams } from 'next/navigation';

import {
  QueryParamAdapter,
  QueryParamAdapterComponent,
} from 'use-query-params';

// From https://github.com/pbeshai/use-query-params/pull/281
export const NextAdapter: QueryParamAdapterComponent = ({ children }) => {
  const router = useRouter();
  const searchParams = useSearchParams()!;

  const adapter: QueryParamAdapter = {
    replace(location) {
      router.replace((location.search as any) || '?', { scroll: false });
    },
    push(location) {
      router.push((location.search as any) || '?', { scroll: false });
    },
    get location() {
      const params = new URLSearchParams(searchParams);
      const search = params.toString();
      return { search };
    },
  };

  return children(adapter);
};
